import i18next from "i18next";
import MwInputText from "./MwInputText";

export const NewInputLang = ({
  value = "",
  onChange,
  langar = true,
  onChangeLang,
  label,
  invalid,
  ...props
}) => {
  return (
    <div className="relative w-full">
   <button
  type="button"
  onClick={onChangeLang}
  className={`absolute border-none outline-none bg-[#251658] text-white px-2 py-[4px] bottom-[5px] 
  hover:bg-[#463977] hover:text-[#ffff] transition-all text-[12px] rounded-md z-10 
  ${i18next.language==="en" ? "right-1 flex-row-reverse text-right" : "left-1 text-left"}`}
  aria-label={langar ? "Switch to English" : "Switch to Arabic"}
>
  {langar ? "En" : "Ar"}
</button>

      <MwInputText
        {...props}
        classNameInput={`pl-12 ${invalid ? "border-red-500" : ""}`}
        label={langar ? `${label} (العربية)` : `${label} (English)`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        invalid={invalid}
        msg=""
      />
     
    </div>
  );
};